import React from "react";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";
import { CiMail } from "react-icons/ci"; // Corrected import
import "./styles/footer.css";
import logo from "../images/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <img
          src={logo}
          alt="Sweet Treats Bakery Logo"
          className="footer-logo"
        />
        <h2 className="footer-title">New Ganesh Bakers</h2>
        <p className="footer-message">
          Thank you for visiting our bakery! We hope to sweeten your day again
          soon 🍰.
        </p>
        <div className="social-links">
          <a
            href="https://www.instagram.com/shri_ganesh_bakery__/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaInstagram />
          </a>
          <a
            href="tel:+919926540204"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaPhoneAlt />
          </a>
          <a
            href="mailto:newganeshbakers5@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <CiMail />
          </a>
        </div>
        <p className="copyright">
          &copy; {new Date().getFullYear()} New Ganesh Bakers. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
